import { useContext } from 'react';
import { InitialStateContext } from '../context/InitialState';

export const isCanaryIslands = geoId => geoId.toString() === '108011';

export const useGeoId = () => {
  const { geoId } = useContext(InitialStateContext);
  return isCanaryIslands(geoId) ? '179' : geoId;
};
